import { z } from "zod";
import { ShortText } from "./common.js";
/**
 * KPI-backed chart card params, shared by `singleKpi` and `chart` — both pin a
 * KPI by id and use the same editor; they differ only in their default
 * `chartType`. `kpiId` is resolved against the KPI library by the mock layer
 * (empty string = "pick the first"); the live value path is ADR-0012's deferred
 * `data_source_ref` binding, out of scope here.
 */
export const CHART_TYPES = [
    "line",
    "area",
    "bar",
    "big-number",
    "mini-stat",
    "trend",
];
export const ChartTypeSchema = z.enum(CHART_TYPES);
export const KpiChartParamsSchema = z
    .object({
    kpiId: ShortText,
    chartType: ChartTypeSchema.optional(),
    showDelta: z.boolean().optional(),
    showCommentary: z.boolean().optional(),
})
    .strict();
export const defaultSingleKpiParams = {
    kpiId: "",
    chartType: "big-number",
};
export const defaultChartParams = {
    kpiId: "",
    chartType: "line",
};
//# sourceMappingURL=kpiChart.js.map